import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/lock.png'


const _withScopeId = n => (_pushScopeId("data-v-6bce3855"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "recover" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Recuperar senha", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imagem de um cadeado."
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Esqueceu sua senha", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Informe o e-mail que usa para acessar o sistema e enviaremos um link verificador.", -1))
const _hoisted_8 = { action: "" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Digite seu e-mail *", -1))
const _hoisted_10 = ["disabled"]

import { isPerformingRequest, useAxios } from '@/api/axios'
import Loader from '@/components/loader/Loader.vue'
import { ref } from 'vue'
import { toast } from 'vue3-toastify'

/* Starts at the top of the page */

export default /*#__PURE__*/_defineComponent({
  __name: 'RecoverPasswordView',
  setup(__props) {

window.scrollTo({
  top: 0,
  behavior: 'auto'
})

const email = ref<string>('')
const axios = useAxios()

function recoverPasword (): void {
  axios.post('/forgot-password', { email: email.value })
    .then(() => {
      toast.success('Um email contendo o link de recuperação de senha foi enviado')
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'login' }))),
        class: "back"
      }, _hoisted_4),
      _createElementVNode("main", null, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("form", _hoisted_8, [
          _createElementVNode("div", null, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
              type: "email",
              placeholder: "ex: joaosasilva@gmail.com",
              name: "email",
              id: "email"
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ]),
          _createElementVNode("nav", null, [
            _createElementVNode("input", {
              autocomplete: "off",
              onClick: recoverPasword,
              disabled: !email.value.length,
              type: "button",
              value: "Solicitar"
            }, null, 8, _hoisted_10)
          ])
        ])
      ])
    ]),
    (_unref(isPerformingRequest))
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          zIndex: 99
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})